import * as React from 'react'
import type { LucideProps } from 'lucide-react'
import { cn } from '@/lib/utils'
import { iconMap, type IconName } from './iconMap'

export type IconSize = 12 | 14 | 16 | 20 | 24 | 32 | 40 | 48 | 64
export type IconStrokeWidth = 1 | 1.5 | 2

export interface IconProps extends Omit<LucideProps, 'size' | 'strokeWidth'> {
  name: IconName
  size?: IconSize
  strokeWidth?: IconStrokeWidth
}

export const Icon = React.forwardRef<SVGSVGElement, IconProps>(
  (
    {
      name,
      size = 20,
      strokeWidth = 2,
      className,
      'aria-label': ariaLabel,
      ...rest
    },
    ref
  ) => {
    const LucideIcon = iconMap[name]
    const isDecorative = !ariaLabel
    return (
      <LucideIcon
        ref={ref}
        width={size}
        height={size}
        strokeWidth={strokeWidth}
        aria-label={ariaLabel}
        aria-hidden={isDecorative || undefined}
        focusable={false}
        className={cn('shrink-0', className)}
        {...rest}
      />
    )
  }
)

Icon.displayName = 'Icon'
